import { FC, MouseEvent } from 'react';
import styled, { css } from 'styled-components';
import { Link } from '@codex/basics';

const StyledLink = styled(Link)`
  position: fixed;
  bottom: 20px;
  left: 15px;
  z-index: 999;
  background: #fafafa;
  text-decoration: none;
  padding: 15px;
  color: #1e249e;
  transition: all .2s ease;
  border: 1px solid #d9d9d9;
  opacity: 1;
  display: none;  
  ${(props) => props.isVisible && css`
    display: block;
  `}
`;

const ArrowIcon = styled.i`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  border-width: 3px 3px 0 0;
  border-style: solid;
  margin: 5px;
  transform: rotate(-45deg);
  &:before{
    content: "";
    box-sizing: border-box;
    right: 0;
    top: -2px;
    position: absolute;
    height: 3px;
    box-shadow: inset 0 0 0 32px;
    transform: rotate(-45deg);
    width: 11px;
    transform-origin: right top;
  }
`;

type Props = {
  handleClick(e: MouseEvent<HTMLElement>): void,
  isVisible?: boolean
};

const BackToTopButton: FC<Props> = ({ handleClick, isVisible = false }) => (
  <StyledLink
    onClick={handleClick}
    isVisible={isVisible}
  >
    <ArrowIcon />
  </StyledLink>
);

BackToTopButton.displayName = 'BackToTopButton';

export default BackToTopButton;

